import { addClass } from "@src/utils/dom";
import "./index.css";
import { toggleScrollFixed } from "@src/utils/globalScrollHelper";

enum EPopupEvent {
  open = "popup-open",
  close = "popup-close",
}
interface IPopupDataset extends DOMStringMap {
  popupId: string;
  popupEvent: EPopupEvent;
}

const ELEMENT_POPUP = "element-popup";
const ELEMENT_POPUP_SHOW = "element-popup__show";

export function closePopup(id: string) {
  const popEle = document.querySelector(
    `.${ELEMENT_POPUP}[data-popup-id='${id}']`
  );
  if (!popEle) return;
  toggleScrollFixed(false);
  popEle.classList.remove(ELEMENT_POPUP_SHOW);
}

export function openPopup(id: string) {
  const popEle = document.querySelector(
    `.${ELEMENT_POPUP}[data-popup-id='${id}']`
  );
  if (!popEle) return;
  toggleScrollFixed(true);
  addClass(popEle, ELEMENT_POPUP_SHOW);
}

export function setupPopup() {
  document.addEventListener("click", function (e: Event) {
    const targetEle = e.target as HTMLElement;
    const sourceEle = targetEle.closest("[data-popup-id]") as HTMLElement;
    const insideEle = targetEle.closest("[data-popup-inside]") as HTMLElement;
    const popupWrap = targetEle.closest(".element-popup") as HTMLElement;
    if (!sourceEle) return;

    // if insideEle not null, means inside; if insideEle as null && popupWrap not null, means gray shadow;
    if (!insideEle && popupWrap && popupWrap.dataset.popupId) {
      closePopup(popupWrap.dataset.popupId);
      return;
    }
    const dataSet = sourceEle.dataset as IPopupDataset;
    if (!dataSet.popupId || !dataSet.popupEvent) return;
    switch (dataSet.popupEvent) {
      case EPopupEvent.close:
        closePopup(dataSet.popupId);
        break;
      case EPopupEvent.open:
        openPopup(dataSet.popupId);
        break;
      default:
        break;
    }
  });
}
